import { render } from "./CookieConsentModal.vue?vue&type=template&id=3dbc4c94&scoped=true&ts=true"
import script from "./CookieConsentModal.vue?vue&type=script&lang=ts"
export * from "./CookieConsentModal.vue?vue&type=script&lang=ts"

import "./CookieConsentModal.vue?vue&type=style&index=0&id=3dbc4c94&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dbc4c94"]])

export default __exports__